import React, { memo } from 'react';

const NewsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M16.41 8.8h-13.128c-1.813 0-3.282 1.433-3.282 3.2v6.4c0 1.767 1.469 3.2 3.282 3.2h1.641v6.4c0 0.884 0.735 1.6 1.641 1.6h3.282c0.906 0 1.641-0.716 1.641-1.6v-6.4h4.923l8.205 6.4v-25.599l-8.205 6.4zM32 15.2c0 2.736-1.575 5.216-4.102 6.4v-12.8c2.511 1.2 4.102 3.68 4.102 6.4z"
        />
    </svg>
);

export default memo(NewsIcon);
